import app from '@/common/public.js';
const { Post } = app;
import { apiName } from '@/common/config.js';

import * as dd from 'dingtalk-jsapi';
import 'dingtalk-jsapi/entry/mobile';
import * as ww from '@wecom/jssdk';

// 钉钉调用部分接口前需要鉴权
export const handlerDDConfig = () => {
  let url = getVerifyWebsiteUrl();
  let param = {
    WebUrl: url,
  };
  return new Promise((resolve, reject) => {
    try {
      Post(
        apiName.GetJsApiConfig,
        param,
        (res) => {
          if (app.GetResultState(res)) {
            let result = res.Result;
            if (!result.AgentId || !result.CorpId) {
              reject(new Error('无效企业'));
            } else {
              dd.config({
                agentId: result.AgentId.toString(), // 必填，微应用ID
                corpId: result.CorpId.toString(), //必填，企业ID
                timeStamp: result.TimesTamp.toString(), // 必填，生成签名的时间戳
                nonceStr: result.NonceStr.toString(), // 必填，自定义固定字符串。
                signature: result.ConfigSignature.toString(), // 必填，签名
                type: 0, //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。
                jsApiList: ['device.geolocation.get'],
              });
            }
          } else {
            reject(new Error('接口返回错误'));
          }
          dd.error(function (err) {
            reject(new Error(err));
          }); //该方法必须带上，用来捕获鉴权出现的异常信息，否则不方便排查出现的问题

          dd.ready(function () {
            resolve('ddConfig success');
          });
        },
        null,
        true,
      );
    } catch (error) {
      reject(error);
    }
  });
};
// 飞书鉴权
export function handlerFeiShuConfig() {
  return new Promise((resolve, reject) => {
    if (!window.h5sdk) {
      reject('invalid h5sdk');
    }
    // 调用config接口的当前网页url
    const url = getVerifyWebsiteUrl();
    let param = {
      WebUrl: url,
    };
    try {
      Post(apiName.GetJsApiConfig, param, (response) => {
        let res = response.Result;
        // 通过error接口处理API验证失败后的回调
        window.h5sdk.error((err) => {
          reject('h5sdk error' + JSON.stringify(err));
        });
        // 调用config接口进行鉴权
        window.h5sdk.config({
          appId: res.AgentId,
          timestamp: res.TimesTamp,
          nonceStr: res.NonceStr,
          signature: res.ConfigSignature,
          jsApiList: [],
          //鉴权成功回调
          onSuccess: (res) => {},
          //鉴权失败回调
          onFail: (err) => {
            reject(`config failed: ${JSON.stringify(err)}`);
          },
        });
        // 完成鉴权后，便可在 window.h5sdk.ready 里调用 JSAPI
        window.h5sdk.ready(() => {
          // window.h5sdk.ready回调函数在环境准备就绪时触发
          resolve('h5sdk ready');
        });
      });
    } catch (e) {
      reject(`后端接口报错：${JSON.stringify(e)}`);
    }
  });
}
// 企业微信鉴权
export const handlerWWConfig = () => {
  let url = getVerifyWebsiteUrl();
  let param = {
    WebUrl: url,
  };
  return new Promise((resolve, reject) => {
    try {
      Post(
        apiName.GetJsApiConfig,
        param,
        (res) => {
          if (app.GetResultState(res)) {
            let result = res.Result;
            if (!result.AgentId || !result.CorpId) {
              reject(new Error('无效企业'));
            } else {
              ww.register({
                corpId: result.CorpId.toString(), //必填，企业ID
                agentId: result.AgentId.toString(), // 必填，微应用ID
                jsApiList: ['getLocation'],
                getConfigSignature: () => {
                  return {
                    timestamp: result.TimesTamp,
                    nonceStr: result.NonceStr,
                    signature: result.ConfigSignature,
                  };
                },
              });
              resolve(result);
            }
          } else {
            reject(new Error('接口返回错误'));
          }
        },
        null,
        true,
      );
    } catch (error) {
      reject(error);
    }
  });
};

async function getConfigSignature(url) {
  // 根据 url 生成企业签名
  // 生成方法参考 https://open.work.weixin.qq.com/api/doc/90001/90144/93197
  return { timestamp, nonceStr, signature };
}

// url有#取#前面的部分，否则取url
function getVerifyWebsiteUrl() {
  const href = location.href;
  const index = href.indexOf('#');
  return index > 0 ? href.substring(0, index) : href;
}
